import { ff } from '@atlassian/jira-feature-flagging';

export const isBacklogWithRelayEnabled = () => ff('jsw.perf.critical-backlog-with-relay');
